// extracted by mini-css-extract-plugin
export var title = "publication-page-module--title--bD+hF";
export var authors = "publication-page-module--authors--AdC8d";
export var venue = "publication-page-module--venue--QQfWH";
export var btn = "publication-page-module--btn--gjrWS";
export var btnBlue = "publication-page-module--btnBlue--xEDex";
export var toggleContainer = "publication-page-module--toggleContainer--Waz7I";
export var toggle = "publication-page-module--toggle--EBJ6p";
export var checked = "publication-page-module--checked--8WReo";